import faker from 'faker'
import moment from 'moment'
import hres6keLabels from 'assets/labels/hres6ke'
import labels from 'src/../config/label.js'

export const mocker = {
  labels () {
    return {
      labels: hres6keLabels
    }
  },
  index () {
    let mockRows = []
    const mockTotal = 100
    for (var i = 1; i <= mockTotal; i++) {
      mockRows.push({
        id: i,
        dtereq: moment().format('DD/MM/YYYY'),
        numseq: faker.random.number().toString().substr(0, 1),
        numotreq: faker.random.number().toString().substr(0, 1),
        dterange: moment().format('DD/MM/YYYY') + ' - ' + moment().format('DD/MM/YYYY'),
        staappr: faker.lorem.word(),
        desc_stareq: faker.lorem.word(),
        remarkap: faker.lorem.sentence(),
        desc_codappr: faker.lorem.word(),
        desc_codempap: faker.lorem.word()
      })
    }

    return {
      total: mockTotal,
      rows: mockRows
    }
  },
  currentNumseq () {
    return 1
  },
  create () {
    let mockDetail = {
      codempid: faker.lorem.word(),
      numseq: faker.random.number().toString().substr(0, 1),
      dtereq: moment().format('DD/MM/YYYY'),
      staappr: '',
      routeno: '',
      dtestrt: moment().format('DD/MM/YYYY'),
      dteend: moment().format('DD/MM/YYYY'),
      timbstr: '',
      timbend: '',
      timdstr: '',
      timdend: '',
      timastr: '',
      timaend: '',
      codrem: '',
      remark: ''
    }

    return mockDetail
  },
  detail () {
    let mockDetail = {
      codempid: faker.lorem.word(),
      numseq: faker.random.number().toString().substr(0, 1),
      dtereq: moment().format('DD/MM/YYYY'),
      staappr: faker.lorem.word(),
      routeno: faker.lorem.word(),
      dtestrt: moment().format('DD/MM/YYYY'),
      dteend: moment().format('DD/MM/YYYY'),
      timbstr: faker.date.past().toString().substr(16, 5),
      timbend: faker.date.past().toString().substr(16, 5),
      timdstr: faker.date.past().toString().substr(16, 5),
      timdend: faker.date.past().toString().substr(16, 5),
      timastr: faker.date.past().toString().substr(16, 5),
      timaend: faker.date.past().toString().substr(16, 5),
      codrem: faker.lorem.word(),
      remark: faker.lorem.word()
    }

    return mockDetail
  },
  dropdowns () {
    let mockCodremEn = {}
    let mockCodremTh = {}
    const mockTotal = Math.floor(Math.random() * 15) + 10
    for (var i = 1; i <= mockTotal; i++) {
      mockCodremEn[faker.lorem.word()] = faker.lorem.word()
      mockCodremTh[faker.lorem.word()] = faker.lorem.word()
    }
    return {
      codrem: {
        en: mockCodremEn,
        th: mockCodremTh
      }
    }
  },
  save () {
    return labels.mockPostMessage
  },
  cancel () {
    return labels.mockPostMessage
  }
}



// WEBPACK FOOTER //
// ./src/api/hres6ke/mocker.js